export default {
  getDomain: {
    method: 'get',
    url: 'domain'
  },
  reviseDomain: {
    method: 'put',
    url: 'domain'
  },
  deleteDomain: {
    method: 'delete',
    url: 'domain'
  },
  addDomain: {
    method: 'post',
    url: 'domain'
  },
  domainBroadcast: {
    method: 'post',
    url: 'domain/broadcast'
  }
}
